// TODO: Need to change and use antd badge wrapper

import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import './iconWithBadge.scss';
const IconWithBadge = _ref => {
  let {
    className,
    iconName,
    badgeContent,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('icon_with_badge relative', className),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: iconName
  }), badgeContent !== EMPTY_STRING ? /*#__PURE__*/React.createElement("div", {
    className: cx('icon_with_badge__badge absolute')
  }, /*#__PURE__*/React.createElement("div", {
    className: "helper_text"
  }, badgeContent)) : null);
};
IconWithBadge.propTypes = {
  iconSize: PropTypes.number,
  className: PropTypes.string,
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  badgeContent: PropTypes.string,
  badgeContentClassName: PropTypes.string
};
IconWithBadge.defaultProps = {
  iconSize: 16,
  className: EMPTY_STRING,
  iconName: 'icon-collaborate',
  iconColor: EMPTY_STRING,
  badgeContent: EMPTY_STRING,
  badgeContentClassName: EMPTY_STRING
};
export default IconWithBadge;